// DOC-DEPS: LLM.md -> src/features/profile/README.md
import React from 'react';
import { X } from 'lucide-react';
import { APP_MODAL_CLOSE_CLASS, APP_MODAL_TITLE_CLASS } from '../../../lib/modalTheme';

interface Props {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

export const InfoSheetPanel: React.FC<Props> = ({ title, onClose, children }) => (
  <div className="app-viewport-fixed z-50 flex min-h-0 flex-col bg-[#F7F9F8]">
    <div
      className="flex shrink-0 items-center justify-between border-b border-slate-200/60 bg-[#F7F9F8]/95 px-4 py-3 backdrop-blur-sm"
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 12px)' }}
    >
      <h2 className={APP_MODAL_TITLE_CLASS}>{title}</h2>
      <button
        onClick={onClose}
        className={`${APP_MODAL_CLOSE_CLASS} flex h-10 w-10 items-center justify-center text-slate-500 transition active:scale-95`}
      >
        <X size={16} strokeWidth={2.5} />
      </button>
    </div>
    <div
      className="app-modal-scroll min-h-0 flex-1 px-5 py-4"
      style={{
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 32px)',
      }}
    >
      {children}
    </div>
  </div>
);
